import { jsx as _jsx } from "react/jsx-runtime";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { PropertyText } from "../Properties";
export function AttributePropertyText(props) {
    var _a;
    const attribute = useCsAttribute();
    const property = (_a = attribute.properties) === null || _a === void 0 ? void 0 : _a[props.propertyId];
    return _jsx(PropertyText, Object.assign({}, props, { property: property }));
}
//# sourceMappingURL=AttributePropertyText.js.map